// src/pages/Home.js
import React from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import homeImage1 from "../assets/homeImage1.jpeg";
import homeImage2 from "../assets/homeImage2.jpeg";

const Home = () => {
  return (
    <div className="bg-dark text-white min-vh-100">
      <Container className="py-5 bg-dark text-white">
        <Row className="align-items-center">
          <Col md={6}>
            <p className="text-uppercase text-secondary">Welcome to my world</p>
            <h1>
              Hi, I’m <span className="text-danger">Narendra Budaniya</span>
              <br />a Professional Software Developer.
            </h1>
            <p className="text-light mt-3">
              Since 2021, I’ve been working as a software developer with
              hands-on experience in backend and frontend technologies, writing
              efficient database queries, and managing end-to-end application
              deployment.
            </p>

            <div className="d-flex flex-column flex-md-row align-items-start gap-4 mt-4">
              {/* Social icons */}
              <div>
                <p className="mb-2 fw-bold">Find with me</p>
                <div className="d-flex gap-3 fs-4">
                  <a
                    href="https://facebook.com/your-profile"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary"
                  >
                    <i className="fab fa-facebook"></i>
                  </a>
                  <a
                    href="https://instagram.com/your-profile"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#E4405F" }}
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a
                    href="https://www.linkedin.com/in/narendra-budaniya/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary"
                  >
                    <i className="fab fa-linkedin"></i>
                  </a>
                </div>
              </div>

              {/* Skills icons */}
              <div className="ms-5">
                <p className="mb-2 fw-bold">Best skill on</p>
                <div className="d-flex gap-4 fs-3">
                  {/* Java */}
                  <i className="fab fa-java" title="Java"></i>

                  {/* React */}
                  <i className="fab fa-react text-info" title="ReactJS"></i>

                  {/* Python */}
                  <i className="fab fa-python text-warning" title="Python"></i>

                  {/* SQL (use database icon as substitute) */}
                  <i className="fas fa-database text-success" title="SQL"></i>
                </div>
              </div>
            </div>
          </Col>

          <Col md={6} className="text-center">
            <Image
              src={homeImage1}
              alt="Profile"
              fluid
              roundedCircle
              className="shadow-lg"
            />
          </Col>
        </Row>

        {/* Who I Am Section */}
        <Row className="mt-5 align-items-center">
          <Col md={6} className="text-center">
            <Image
              src={homeImage2}
              alt="Profile"
              fluid
              rounded
              className="shadow"
            />
          </Col>
          <Col md={6}>
            <h4 className="text-white">Who I Am?</h4>
            <p>
              Enthusiastic Software Engineer who is eager to contribute to team
              success through hard work, attention to details. Skilled in Data
              Structure & Algorithm, Core Java, OOPs, HTML, CSS. Graduated from
              IIT Roorkee with a degree of Integrated M tech in Geophysical
              Technology.
            </p>
            <a
              href="/Narendra_fs_cv.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button variant="danger" className="mt-3">
                View CV
              </Button>
            </a>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Home;
